<template>
  <div>
    <div style="padding-top : 100px;">
        <div class="ebookHeader">
            <div style="margin-top:10px;"><a href="#" @click="backToIndex" class="backBtn backBtn-eBook">Back</a></div>
            <div style="margin-top:100px;" @click="showHint"><a href="#" class="backBtn backBtn-eBook">Hint</a></div>
        </div>
        <div id="test" :style="{height : height+'px'}" v-loading.fullscreen.lock="fullscreenLoading">
            <div id="body" :style="{height : (height*0.8)+'px'}" style="display:flex;flex-direction: row;">
                <div id="body-left" style="width:75%;">
                    <div :style="{height : (height*0.9)+'px'}" style="text-align: center;">
                        <div style="color: white;margin:10px;font-size:35px;">{{unit.title}}</div>
                        <el-card :style="{width:(width*0.55)+'px'}" style="margin: auto; overflow: auto;">
                            <div style="text-align: left;float: left;">{{(index+1)}}</div>
                            <div style="text-align:center;float: right;cursor:pointer;">
                                <i v-if="mode == 'w1' || mode=='w2' || mode=='w3' || mode=='w4'"  style="font-size:35px;color:rgb(79, 79, 230)" class="el-icon-mic" @click="playAudioJs(currentItem.audioEn)"></i>                            
                            </div>
                            <div v-if="mode != 'st'">
                                <div v-if="mode == 'w1' || mode == 'w2'" style="font-size:50px;">
                                    <div v-if="currentItem.title">
                                        {{currentItem.title}}
                                    </div>
                                    <div v-else></div>
                                </div>
                                <div v-if="mode=='w1'">
                                    <img :style="{height:(height*0.4)+'px'}" style="margin:5px;transform:scale(1.0);" alt=""
                                        :src="currentItem.picture">
                                </div>
                                <div v-if="mode=='w4' || mode=='w1'" style="font-size: 40px;text-overflow: ellipsis;">
                                    <h4 v-if="currentItem.interpretation == undefined || currentItem.interpretation.length ==0">
                                        
                                    </h4>
                                    <span v-for="(item,index) in currentItem.interpretation" :key="index" style="font-size:0.6em;">
                                        <span>{{item.meaning}}<span v-if="item.type" style="color:gray;">{{"["+item.type+"]"}}</span></span>
                                        <span>；</span>
                                    </span>
                                </div>
                            </div>
                            <div v-else>
                                    <div v-if="currentItem.title == undefined"></div>
                                    <div v-else style="font-size:25px;font-family: times new roman;" v-html="currentItem.title"></div>
                                    <div v-if="currentItem.interpretation" style="padding: 14px;font-size: 20px;text-overflow: ellipsis;">
                                        {{currentItem.interpretation}}
                                    </div>
                            </div>
                        </el-card>
                        <div v-if="mode != 'st'" :style="{width: (width*0.55)+'px'}" style="margin: 20px auto;">
                                <el-input v-model="answer" @keyup.enter.native="confirm" autofocus style="font-family: chewy; font-size: 30px;"></el-input>
                        </div>
                        <div v-else :style="{width: (width*0.55)+'px'}" style="margin: 20px auto;">
                                <el-input type="textarea" autosize v-model="answer" @keyup.enter.native="confirm($event)" autofocus style="font-family: chewy; font-size: 30px;"></el-input>
                        </div>
                    </div>
                    <!-- <div :style="{height : (height*0.2)+'px',width: (width*0.4)+'px'}" style="margin: auto;">
                        
                    </div> -->
                </div>
                <div id="body-right" style="width:25%;">
                    <div :style="{height : (height)+'px'}" style="display:flex;flex-direction:column;">
                            <div v-for="(item,index) in tips" :key="index" style="margin:10px;cursor:pointer;">
                                <el-card shadow="always">
                                    <el-row justify="space-between">
                                        <el-col :span="12"><span style="font-size:30px;color:#c53931">{{item.key}}</span></el-col>
                                        <el-col :span="12" style="text-align:right;color:green;font-size: 30px;"><span>{{item.value}}</span></el-col>
                                    </el-row>
                                    </el-card>
                            </div>
                    </div>
                </div>
                <el-dialog title="Result" :visible.sync="dialogResultVisible" @close="close">
                <div style="border:1px solid gray;border-radius: 10px;">
                    <h1  style="text-align: center;">{{"击败了 "+defeatNumber+"% 的小伙伴"}}</h1>
                    <div v-for="(item,index) in tips" :key="index" style="margin:10px;">
                        <el-row justify="space-between">
                            <el-col :span="12" style="font-size:30px;color:#c53931;text-align: center;"><span>{{item.key}}</span></el-col>
                            <el-col :span="12" style="text-align:center;color:green;font-size: 30px;"><span>{{item.value}}</span></el-col>
                        </el-row>
                    </div>
                    </div>
                    <div slot="footer" style="text-align: center;">
                        <el-button @click="close(1)" style="font-family: chewy;">got it</el-button>
                    </div>
                </el-dialog>
            </div>

        </div>
    </div>
</div>
</template>

<script>

export default {
    name : 'test',
    data () {
        return {
            fullscreenLoading : false,
            height : document.documentElement.clientHeight*0.95,
            width : document.documentElement.clientWidth,
            tips : [{key : "Total",value:0},{key:"Correct",value:0},{key:"Wrong",value:0},{key:"Accuracy",value:'0%'},{key:"Spend",value:"00 : 00"}],
            answer : '',
            lastAnswer : '',
            words : [],
            currentItem : {},
            index : 0,
            mode : null,
            dialogResultVisible : false,
            unit : {},
            startTime : '',
            defeatNumber : 0,
            wrongWords : [],
            spend : 0,
            task : null,
            doubleClose : false,
            tmpSentence : '',
            isNotebook : false,
        }
    },
    watch : {
        words : function(words){
            this.tips[0].value = words.length;
        },
        spend : function(val){
            this.tips[4].value = this.formatSeconds(val);
        },
        currentItem : function(item){
            if(item == undefined)
                return;
            if(this.mode == 'st'){
                item.blanks = item.blanks ? JSON.parse(item.blanks) : '[]';
                this.tmpSentence = item.title;
                var newSentence = this.tagWordsBlank(item.title, item.blanks);
                item.title = newSentence;
                this.currentItem = item;
                this.playAudio();
            }else if(this.mode != 'w4')   {
                this.currentItem.interpretation = this.currentItem.interpretation==undefined ? '' : JSON.parse(this.currentItem.interpretation);
                this.playAudioJs(item.audioEn,true);
            }else{
                this.currentItem.interpretation = this.currentItem.interpretation==undefined ? '' : JSON.parse(this.currentItem.interpretation);
            }
        }
    },
    mounted : function(){
        let _this = this;
        _this.mode = _this.$route.params.type;
      _this.unit = _this.$route.params.unit;
      if(_this.mode == null){
            _this.$router.replace({name:"index"})
            return;
        }
        if(_this.$route.params.notebook){
          //notebook
          _this.request("GET","/test/notebook/"+_this.$route.params.customerUserId+"/"+_this.mode,null,function(data){
              _this.init(data);
          });
        }else{
            if(_this.mode == 'st'){
                //句子
                _this.request("GET","/unit/"+_this.unit.id+"/sentences",null,function(data){
                    _this.init(data);
                });
            }else{
                //单词
                _this.request("GET","/unit/"+_this.unit.id+"/words",null,function(data){
                    _this.init(data);
                });
            }
        }
    },
    methods : {
        tagWordsBlank : function(sentence,blanks){
            let blankSentence='';
            //对blanks进行排序
            blanks.sort(function(a,b){
                return a.index - b.index;
            });
            let index = 0;
            let ii = 0;
            while(ii<blanks.length){
                if(index < blanks[ii].from){
                    blankSentence += sentence.substring(index,blanks[ii].from);
                    index = blanks[ii].from;
                }else{
                    let word = sentence.substr(blanks[ii].from,blanks[ii].len);
                    blanks[ii].name = word;
                    for(let j=0; j<word.length; j++){
                        if(j == 0){
                            blankSentence += '<span style="text-decoration：underline;color:blue;">';
                        }
                        blankSentence+='_'
                        if(j==word.length-1){
                            blankSentence += '</span>';
                        }
                    }
                    index = blanks[ii].from + blanks[ii].len;
                    ii++;
                }
            }
            if(index < sentence.length){
                blankSentence += sentence.substring(index,sentence.length)
            }
            return blankSentence;
        },
        formatSeconds : function(seconds){
            var minute = 0;
            if(seconds >= 60){
                minute =  parseInt(seconds/60);
                seconds = parseInt(seconds%60);
            }
            if(minute < 10)
                minute = "0"+minute;
            if(seconds < 10)
                seconds = "0"+seconds;
            return minute+" : "+seconds;
        },
        havenWrong(word){
          for(let i=0; i<this.wrongWords.length; i++){
              if(this.wrongWords[i].id == word.id){
                  return true;
              }
          }
          return false;
        },
        addWrongWords : function(word, wrongWord){
            this.wrongWords.push({id : word.id, answer : wrongWord});
        },
        backToIndex : function(){
            if(this.task != null)
                clearInterval(this.task);
            this.$router.go(-1);
        },
        showHint : function(){
            let hint = this.mode == 'st' ? this.tmpSentence : this.currentItem.title;

            this.$message({
                type : "success",
                message : hint
            })
        },
        close : function(){
            this.backToIndex();
        },
        init : function(items){
            if(items.length == 0){
                if(this.mode == 'st'){
                    this.$alert("未录入句子，请联系管理员");
                }else{
                    this.$alert("未录入单词，请联系管理员");
                }
            }else{
                this.words = items;
                this.currentItem = this.words[0];
                // this.playAudio();
                this.startTime = new Date();
                var _this = this;
                //计时
                this.task = setInterval(function(){
                    _this.spend++;
                },1000);
            }
            
        },
        updateAccuracyRate : function(){
            var tips = this.tips;
            var ct = tips[1].value;
            var wt = tips[2].value;
            var ar = parseInt(ct*100/(ct+wt));
            
            tips[3].value = ar+"%";            
        },
        confirm : function(){
            if(this.task == null){
                return ;
            }
            if(this.answer.length == 0){
                return;
            }
            if(this.mode == 'st'){
                //句子模式为输入框为textarea，处理回车换行
                this.answer = this.answer.replace('\r','').replace("\n",'');
                // event.preventDefault();
            }
            if(this.currentItem.blanks && this.currentItem.blanks.length != 0){
                var blanks = this.currentItem.blanks;
                for(var i in blanks){
                    if(!blanks[i].isOk){
                        if(blanks[i].name == this.answer){
                            blanks[i].isOk = true;
                            //补全
                            var sentence = this.currentItem.title;
                            var start = sentence.indexOf("_");
                            var end = start+blanks[i].name.length;
                            sentence = sentence.substring(0,start) + blanks[i].name + sentence.substring(end);
                            this.currentItem.title = sentence;
                            this.answer = '';
                            
                            this.playAudioJs("/media/correct.mp3");
                        
                        }else{
                            if(this.lastAnswer == this.answer){
                                return;
                            }
                            if(!this.havenWrong(this.currentItem)){
                                this.tips[2].value++;
                            }
                            this.updateAccuracyRate();
                            this.playAudioJs("/media/wrong.mp3");
                            this.addWrongWords(this.currentItem, this.answer);
                            this.lastAnswer = this.answer;
                        }
                        break;
                    }
                    
                }
                if(blanks[blanks.length-1].isOk){
                    
                    this.tips[1].value++;
                    this.updateAccuracyRate();
                    if(this.index == this.words.length -1){
                        //最后一个句子
                        this.successAction();
                    }else{
                        
                        var _this = this;
                        setTimeout(function(){
                            //下个句子
                            _this.index++;
                            _this.currentItem = _this.words[_this.index];
                            // _this.playAudio();
                        },500);
                        
                    }
                }
            }else{
                if(this.currentItem.title.replace(/ /g,'') == this.answer.replace(/ /g,'')){
                    this.tips[1].value++;
                    this.updateAccuracyRate(); 
                    this.answer = '';
                    if(this.index == this.words.length - 1){
                        this.successAction();
                    }else{
                        this.index++;
                        this.currentItem = this.words[this.index];
                        this.updateAccuracyRate();
                        this.playAudioJs("/media/correct.mp3");
                        // this.playAudio();
                    }
                }else{
                    //错误之后重复回车
                    if(this.lastAnswer == this.answer){
                        return;
                    }
                    if(!this.havenWrong(this.currentItem)){
                        this.tips[2].value++;
                    }
                    this.updateAccuracyRate();
                    this.playAudioJs("/media/wrong.mp3");
                    this.addWrongWords(this.currentItem, this.answer);
                    this.lastAnswer = this.answer;
                }
            }
        },
        successAction : function(){
            clearInterval(this.task);
            
            var _this = this;
            var accuracy = parseInt(_this.tips[3].value.replace("%",""));
            var spend = parseInt((new Date().getTime() - _this.startTime.getTime())/1000);
            _this.request("POST","/test/word",{
                startTime : _this.startTime,
                spendSeconds : spend,
                mode : _this.mode,
                result : accuracy,
                unitId : _this.unit.id == undefined ? '1ea729ff5aaa7f08c498fd138000000' : _this.unit.id,
                wrongAnswers : _this.wrongWords
            },function(){
                _this.request("GET","/test/defeat", {
                    params : {
                        spendSeconds : spend,
                        result : accuracy,
                        type : _this.mode,
                        unitId : _this.unit.id == undefined ? '1ea729ff5aaa7f08c498fd138000000' : _this.unit.id
                    }
                },function(data){
                    _this.defeatNumber = data;
                    _this.dialogResultVisible = true;
                    if(_this.tips[3].value == "100%"){
                        _this.playAudioJs("/media/100.mp3");
                    }else{
                        _this.playAudioJs("/media/success.mp3");
                    }
                })
            })            
        },
        playAudio : function(){
            if(this.mode != 'w4'){
                var _this = this;
                setTimeout(function(){
                    if(_this.$refs.sound != undefined)
                        _this.$refs.sound.play();
                },1000);
            }
        },
        playAudioJs : function(path,isTimeout){
            if(path == undefined){
                this.$message("无语音");
                return ;
            }
            var audio = document.createElement("AUDIO");
            audio.src = path;
            if(isTimeout){
                setTimeout(function(){
                    audio.play();
                },1000);
            }else{
                audio.play();
            }
        }
    },
    destroyed : function(){
        if(this.task != null)
            clearInterval(this.task);
    }
}
</script>

<style>
#test{
    position: absolute;
    top : 0px;
    left : 0px;
    width : 100%;
    height : 100%;
    background: #172646;
    font-family: chewy;
}
.wordItem:hover{
    border: 1px solid gray;
    border-radius: 5px;
}
.backBtn {
    color: #fff!important;
    background: #39c531;
    float: left;
    font-family: chewy,verdana,arial;
    font-size: 26px;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    position: relative;
    text-decoration: none;
    -webkit-transition: all .1s ease-out;
    transition: all .1s ease-out;
    white-space: nowrap;
    z-index: 1;
}
.backBtn-eBook {
    margin: -3px 5px 0 10px;
    z-index: 9999;
}
.backBtn::after {
    border-bottom: 20px solid transparent;
    border-right: 15px solid #39c531;
    border-top: 20px solid transparent;
    content: "";
    display: block;
    left: -15px;
    height: 0;
    position: absolute;
    top: 0;
    -webkit-transition: all .1s ease-out;
    transition: all .1s ease-out;
    width: 0;
}
.ebookHeader {
        position: absolute;
        left:10px;
        top:10px;
}
@font-face {
    font-family: 'Chewy';
    font-style: normal;
    font-weight: 400;
    src: local('Chewy'), url(/fonts/Chewy.woff2) format('woff2'), url(/fonts/Chewy.woff) format('woff');
}


</style>